/* Copyright (c) 2021 Caring Transitions Online Auctions. All Rights Reserved. */

// library imports
import { Component, createRef } from 'react';
import { Link } from 'react-router-dom';
import { Button, Form, Row, Col, Modal, Spinner } from 'react-bootstrap';
import axios from 'axios';
import DatePicker from "react-datepicker";
import moment from 'moment';
import * as momentTz from 'moment-timezone';

// project imports
import { getSellerUrl, getSellerHeaders } from 'shared/http';
import { locationlist, salelist, statelist, citylist, saledelete, salesNoteCount } from 'shared/settings/apiconfig';
import Datatable from 'shared/datatable';
import toast from 'shared/toast';
import { ToasterMessage } from 'shared/toast/toast';
import Notes from './Notes';
import { REFRESH_TOKEN, isTokenExpiredBeforeOneHour, getToken } from 'shared/settings/token';
import store from 'features/store';

// style imports
import "react-datepicker/dist/react-datepicker.css";
import './SalesList.scss';
import { ArrayValueReorder } from 'shared/modifiers';
import { NoData } from 'features/components/redirect/NoData';

/**
 * this page is used to show sale list in table
 * 
 * @param props
 * 
 * @return  sales list html code
 * 
**/

export class SalesList extends Component {
    locations;
    initialSearchState;
    search;
    startDatePicker;
    endDatePicker;
    config;
    id;
    filterSearch;
    test;
    stateList;
    tableData;
    constructor(props) {
        super(props);

        this.dataTable = createRef();

        /* initial search state */
        this.initialSearchState = {
            title: { field: 'title', value: '', op: 'LIKE', join: 'AND' },
            client: { field: 'client', value: '', op: 'LIKE', join: 'AND' },
            starttime: { field: 'starttime', value: '', op: '<=', join: 'AND' },
            endtime: { field: 'starttime', value: '', op: '>=', join: 'AND' },
            city: { field: 'city', value: '', op: 'LIKE', join: 'AND' },
            state: { field: 'state', value: '', op: 'LIKE', join: 'AND' },
            zipcode: { field: 'zipcode', value: '', op: 'LIKE', join: 'AND' },
            locationid: { field: 'locationid', value: '', op: 'LIKE', join: 'AND' },
            active: { field: 'endtime', value: false, op: '>', join: 'AND' },
            inactive: { field: 'endtime', value: false, op: '<', join: 'AND' },
            isDeleted: { field: 'isDeleted', value: 0, op: '=', join: 'AND' }

            // isactive: ''

        }
        const searchState = JSON.parse( JSON.stringify(this.initialSearchState));
        // searchState.endtime.value = new Date();
        this.state = {
            search: searchState,
            filterSearch: searchState,
            searchData: false,
            locations: [],
            modal: false,
            tableData: [],
            salesDetails: {},
            issearch: false,
            stateList: [],
            cityList: [],
            name : "SaleList",
            SaleId: '',
            deleteModal:false,
            deleteLoading:false,
            locationlength: 0,
            deleteStatus: { show: false, type: '', message: '' },
            notesCount: [],
            errorpageredirect: false,
            errorType: '',
            locationErrorMsg: 'A location is required. Please select a location from the dropdown to continue.'
        }

        this.config = {
            name: 'sale',
            url: salelist,
            createurl: '/sales/create',
            search: {},
            params: {},
            columns: [
                {
                    name: '', property: 'id', columnType: 'actions', actions: ['notes', 'dashboard', 'edit'], customHeader: <> <div><Button className="save-button" style={{ marginLeft: "10%" }} onClick={() => this.navigateToEdit()}>+ Create</Button></div> </>, width: '100px',
                    actionEvents: { notes: (id) => { this.viewNotes(id) }, dashboard: (row, state) => { this.props.history.push({ pathname: `/sales/dashboard/${row['id']}`, state: { ...state,locationAll : this.state.search.locationid.value === 'All',cityAll : this.state.search.city.value === 'All',
                    saletitle: row, isClosed: row["status"] && row["status"].toLowerCase() === "closed",maintain: this.state} }) }, edit: (row, state) => { state['itemcount'] = row['itemcount'];state['locationAll'] = this.state.search.locationid.value === 'All';state['cityAll'] = this.state.search.city.value === 'All'; this.props.history.push({ pathname: `/sales/edit/${row['id']}`, state: state }) } }
                },
                { name: 'Title', property: 'title', sort: true, width: '250px' },
                { name: 'Sale Address', property: 'city', sort: true, width: '180px', columnType: 'custom', customColumn: this.customAddress },
                { name: 'Start Date', property: 'starttime', sort: true, width: '150px', columnType: 'custom', customColumn: this.customStartTime },
                { name: 'End Date', property: 'endtime', sort: true, width: '150px', columnType: 'custom', customColumn: this.customEndTime },
                { name: 'Items', property: 'itemcount', sort: false, width: '60px', columnType: 'custom', customColumn: this.itemLink, needState: true },
                {
                    name: '', property: 'id', columnType: 'actions', actions: ['accordion'], customHeader: <></>, width: '75px',
                    accordion: this.accordionValue
                }
            ],
            sort: [
                {
                    "field": ["endtime"],
                    "direction": "desc"
                }],
            pagination: true,
            field: ['id', 'title', 'city', 'state', 'zipcode', 'starttime', 'endtime', 'itemcount', 'client', 'contactname', 'locationid', 'locationtitle', 'modifieddate', 'status', 'invoicegenerated', 'timezonename', 'initiateautodebit','address1','contactemail','contactmobile','country',],
            notesGreenCircle: (data) => this.notesGreenCircle(data)
        };

        if (props.location.state && props.location.state.datatable && props.location.state.datatable.search) {
            let tempSearch = { ...this.initialSearchState };
            const search = [...props.location.state.datatable.search];

            search.forEach(element => {
                let temp = { ...element };
                if (typeof temp['value'] === 'string') {
                    temp['value'] = temp['value'].replace(/(^\*)|(\*$)/g, '');
                }
                if (temp['field'] === 'starttime') {
                    temp['value'] = new Date(temp['value']);
                }
                if (temp['field'] === 'starttime' && temp['op'] === '>=')
                    temp['field'] = 'endtime';
                tempSearch[temp['field']] = temp;
            });

            this.state['search'] = tempSearch;
            this.state['issearch'] = Boolean(search.length);
            this.state['searchData'] = true;
            if (this.state['search']['state'].value)
                this.getCity();
        }
        if(this.props.location.state && this.props.location.state.createSearch){
            this.state['searchData'] = true;
            this.enableSearch();
        }
        this.locations = [];
        this.search = {};
        this.startDatePicker = false;
        this.endDatePicker = false;
        this.id = null;
        this.filterSearch = {};
        this.stateList = [];
        this.tableData = [];
    }

    componentDidMount = () => {
        this.getLocationStateList();
        if(this.props.location.state && this.props.location.state.createSearch){
            this.setState({
                ...this.state,
                locationErrorMsg: '',
                search:{
                    ...this.state.search,
                    endtime:{
                        ...this.state.search.endtime,
                        value: ''
                    }
                }
            })
        }
        if(this.props?.location?.state?.datatable?.search){
            this.setState({
                locationErrorMsg: '',
            })
        }
        window.history.pushState(null, null, window.location.pathname);
        window.addEventListener('popstate', this.onBack); 
    }
    onBack = (e) => {
        e.preventDefault();
        window.history.pushState(null, null, window.location.pathname);
    }

    // handle enter key search
    _handleKeyDown = (e) => {
        if (e.key === 'Enter' && this.state.search.locationid.value && !this.state.errorMessage && !this.state.locationErrorMsg) {
            this.enableSearch()
        }
    }

    /*custom link */
    itemLink = (values, state) => {
        return (
            <div style={{marginTop: "13px", marginLeft: "10px"}}>
                <Link to={{ pathname: `/sales/items/${values['id']}`, state: { prevPath: this.props.location.pathname,locationAll : this.state.search.locationid.value === 'All',cityAll: this.state.search.city.value === 'All', saleid: values['id'],locationid: values['locationid'], saletitle: values['title'], ...state, isClosed: values["status"] && values["status"].toLowerCase() === "closed",state:this.state } }}>
                    <p className="item-link">{values['itemcount']}</p>
                </Link>
            </div>
        )
    };

    customAddress = (values) => {
        return (values['city'] ? values['city'] + ', ' : '') + (values['state'] ? values['state'] + ', ' : '') + (values['zipcode'] ? values['zipcode'] : '');
   
    }

    customStartTime = (values) => {
        if (values['starttime'] != null) {
            let date = moment.tz(values['starttime'], values['timezonename']).local();
            return `${date.format('MM/DD/YYYY hh:mm A')} ${momentTz.tz(momentTz.tz.guess()).zoneAbbr()}`;
        }
        else
            return '- - -';
    }
    customEndTime = (values) => {
        if (values['endtime'] != null) {
            let date = moment.tz(values['endtime'], values['timezonename']).local();
            return `${date.format('MM/DD/YYYY hh:mm A')} ${momentTz.tz(momentTz.tz.guess()).zoneAbbr()}`;
        }
        else
            return '- - -';
    }


    /* called when create clicked */
    navigateToEdit = () => {
        if (!isTokenExpiredBeforeOneHour(REFRESH_TOKEN)) {
            let data = {};
            data['datatable'] = this.state.tableData.stateData;
            this.props.history.push({ pathname: '/sales/create', state: data });
        } else {
            if (getToken(REFRESH_TOKEN)) {
                store.dispatch({ type: 'TOGGLE_SESSION_MODAL', payload: true });
            }
        }     
    }

    /* called when note clicked */
    viewNotes = (id) => {
        const data = this.tableData.data.filter(x => x.id === id);
        this.setState({
            ...this.state,
            modal: true,
            salesDetails: data[0]
        });
        this.id = id;
    }

    getNotesCount = async () => {
        const salesList = JSON.parse(JSON.stringify(this.tableData.data));
        const postData = salesList.map(x => { return { saleid : x.id } });

        axios.post(getSellerUrl(salesNoteCount), JSON.stringify({ data: postData }), getSellerHeaders()).then(res => {
            this.setState({
                notesCount: res.data.data
            });
        }).catch(error => error);
    }

    notesGreenCircle = (data) => {
        const count = this.state.notesCount.filter(x => x.SALE_ID === data.id);
        return count.length > 0 ? count[0].SNOT_Count > 0 : false;
    }

    /* called when save or close note */
    hideNotes = () => {
        this.setState({
            ...this.state,
            modal: false
        });
    }

    /* Get Location and state list */
    getLocationStateList = async () => {
        await axios.all([
            await axios.post(getSellerUrl(locationlist), JSON.stringify({ field: ['id', 'title'] }), getSellerHeaders()),
            await axios.get(getSellerUrl(statelist), getSellerHeaders())
        ])
            .then(response => {
                this.locations = response[0].data.data;
                this.stateList = ArrayValueReorder(response[1].data.data, 'state');
                if (this.props?.location?.state?.locationAll) {
                    this.setState({
                        ...this.state,
                        search: {
                            ...this.state.search,
                            locationid: {
                                ...this.state.search.locationid,
                                value: 'All'
                            }
                        }
                    })
                }
               
                if (this.locations.length == '1') {
                    this.setState({
                        ...this.state,
                        locations: ArrayValueReorder(response[0].data.data, 'title'),
                        location: this.locations[0].title,
                        stateList: this.stateList,
                        locationlength: this.locations.length,
                        isdisabled: true,
                        locationErrorMsg: '',
                        search: {
                            ...this.state.search,
                            locationid: {
                                ...this.state.search.locationid,
                                value: this.locations[0].id
                            },
                        }
                    });
                }
                else {
                    this.setState({
                        ...this.state,
                        locations: ArrayValueReorder(response[0].data.data, 'title'),
                        stateList: this.stateList,
                        locationlength: this.locations.length,
                    });
                }
               
            })
            .catch(error => {
                if(error.response?.status == 401 || error.response?.status == 404) {
                    this.setState({
                        errorpageredirect: true,
                        errorType: error.response.status == 401 ? 'expiryError' : error.response.status == 404 ? 'noData' : ''
                    })
                }
                // toast.error(error?.response?.data['message']);
            });
    }

    /* get city list */
    getCity = () => {
        let cityList = [];
        if (this.state.search.state.value) {
            axios.get(getSellerUrl(`${citylist}/${this.state.search.state.value}`), getSellerHeaders())
                .then(response => {
                    cityList = ArrayValueReorder(response.data.data, 'city');
                    cityList = cityList.filter((city, index) => {
                        const _city = JSON.stringify(city);
                        return index === cityList.findIndex(obj => {
                            return JSON.stringify(obj) === _city;
                        });
                    });
                    this.setState({
                        cityList: cityList,
                        search: {
                            ...this.state.search,
                            city: {
                                ...this.state.search.city,
                                value: ''
                            }
                        }
                    });
                    if (this.props?.location?.state?.cityAll) {
                        this.setState({
                            ...this.state,
                            search: {
                                ...this.state.search,
                                city: {
                                    ...this.state.search.city,
                                    value: 'All'
                                }
                            }
                        })
                    }
                })
                .catch(error => {
                });
        }
    }

    /* called when search input changes */
    searchInputChange = (event) => {
        let eventValue = event.target.value.trimStart();
        const fieldName = event.target.name;
        if (event.target.name === 'active' || event.target.name === 'inactive') {
            eventValue = !this.state.search[event.target.name].value

        }
        this.setState((prevState) => ({
            ...prevState,
            issearch: true,
            search: {
                ...prevState.search,
                [fieldName]: {
                    ...prevState.search[fieldName],
                    value: eventValue,
                },
            },
        }), () => {
            const { search } = this.state;
            const locationSelected = search.locationid.value;
        
            let errormsg = '';
            if (locationSelected === "All") {
                const othersEmpty = Object.keys(search)
                .filter(key => key !== "locationid" && key !== "isDeleted")
                .every(key => !search[key].value);

                errormsg = othersEmpty ? 'Please select one additional field to proceed with Location: All' : '';
            } else {
                errormsg = locationSelected ? '' : this.state.locationErrorMsg;
            }

            this.setState({
                locationErrorMsg: errormsg
            }, () => {
                if (eventValue === ''){
                    this.checkSearch();
                    this.setState({
                        search: {
                            ...this.state.search,
                            city: {
                                ...this.state.search.city,
                                value: ''
                            }
                        }
                    });
                }
                if (event.target.name === 'state') {
                    this.getCity();
                }
            });
        });
    }

    /* set date for date input change */
    setDate = (control, date) => {
        this.setState({
            ...this.state,
            issearch: true,
            search: {
                ...this.state.search,
                [control]: {
                    ...this.state.search[control],
                    value: date
                },
            }
        }, () => {
            let errorMessage = '';
            const { starttime, endtime } = this.state.search;
        
            if (starttime.value && endtime.value) {
                const start = new Date(starttime.value);
                const end = new Date(endtime.value);
              
                // normalize to remove time (set to midnight)
                const startDate = new Date(start.getFullYear(), start.getMonth(), start.getDate());
                const endDate = new Date(end.getFullYear(), end.getMonth(), end.getDate());
              
                // find earliest and latest date
                const minDate = startDate < endDate ? startDate : endDate;
                const maxDate = startDate > endDate ? startDate : endDate;
              
                const oneYearLater = new Date(minDate);
                oneYearLater.setFullYear(oneYearLater.getFullYear() + 1);
              
                if (end > start && control === 'starttime' ) {                
                    this.setState(prev => ({
                        issearch: true,
                        search: {
                            ...prev.search,
                            endtime: {
                                ...prev.search.endtime,
                                value: null
                            }
                        }
                    }));
                } else if (maxDate > oneYearLater) {
                  errorMessage = "Please select a date range within any 12 month period";
                }
              }
              if(this.state.search.locationid.value){
                this.setState({  locationErrorMsg: '' });
              }
              this.setState({ errorMessage });
        
          });
        };

    /* called when clear all in search clicked */
    resetState = () => {
        this.setState({
            ...this.state,
            errorMessage: '',
            locationErrorMsg: 'A location is required. Please select a location from the dropdown to continue.',
            search: this.initialSearchState,
            searchData: false,
            issearch: false,
        }, () => {
            this.dataTable.current.searchData();
        });
    }



    /* called when search button clicked */
    enableSearch = () => {
        let search = {};
        search = {
            title: { ...this.state.search.title, value: this.state.search.title.value ? '*' + this.state.search.title.value + '*' : '' },
            client: { ...this.state.search.client, value: this.state.search.client.value ? '*' + this.state.search.client.value + '*' : '' },
            starttime: { ...this.state.search.starttime, value: this.state.search.starttime.value ? moment(new Date(this.state.search.starttime.value)).endOf('day').format("YYYY-MM-DD HH:mm:ss") : '' },
            endtime: { ...this.state.search.endtime, value: this.state.search.endtime.value ? moment(new Date(this.state.search.endtime.value)).startOf('day').format("YYYY-MM-DD HH:mm:ss") : '' },
            state: { ...this.state.search.state },
            zipcode: { ...this.state.search.zipcode },
            isDeleted: { field: 'isDeleted', value: 0, op: '=', join: 'AND' }
        }
        if(this.state.search.locationid.value !== 'All'){
            search['locationid'] = { ...this.state.search.locationid }
        }
        if(this.state.search.city.value !== 'All'){
            search['city']= { ...this.state.search.city }
        }
        if (!(this.state.search.active.value && this.state.search.inactive.value)) {
            let currentDate = moment.utc(new Date()).format("YYYY-MM-DD HH:mm:ss");
            search['active'] = { ...this.state.search.active, value: this.state.search.active.value ? currentDate : '' };
            search['inactive'] = { ...this.state.search.inactive, value: this.state.search.inactive.value ? currentDate : '' };
        }
        this.setState({
            filterSearch: search,
            searchData: true,
        }, () => {
            this.dataTable.current.searchData();
        });
    }

    /* check enable search and clear all */
    checkSearch = () => {
        let isenable = false;
        let issearchData = this.state.searchData;
        for (let control of Object.keys(this.state.search)) {
            if (this.state.search[control].value && control !== 'active' && control !== 'inactive') {
                isenable = true;
                break;
            }
        }
        this.setState({
            ...this.state,
            search: isenable ? this.state.search : this.initialSearchState,
            searchData: isenable ? this.state.searchData : false,
            issearch: isenable
        }, () => {
            if (!isenable && issearchData)
                this.dataTable.current.searchData();
        });
    }

    /* called when accordion clicked */
    accordionValue = (tr) => {
        let row = JSON.stringify(tr)
        row = row.replace(/""/g, '"- - - "')
        row = JSON.parse(row)
        return (
            <div style={{ padding: "1% 2%" }}>
                {row && Object.keys(row).length ?
                    <div className="d-flex" style={{ justifyContent: "space-evenly"}}>
                        <div style={{ margin: "0 5%" }}>
                            <div className="text-accordion-header">Client Name</div>
                            <div>{row['client']}</div>
                        </div>
                        <div style={{ margin: "0 5%" }}>
                            <div className="text-accordion-header">Contact</div>
                            <div>{row['contactname']}</div>
                        </div>
                        <div style={{ margin: "0 5%" }}>
                            <div className="text-accordion-header">Location</div>
                            <div>{row['locationtitle']}</div>
                        </div>
                        <div style={{ margin: "0 5%", }}>
                            <div className="text-accordion-header">Last Modified</div>
                            <div>{tr !== "" && moment.utc(row['modifieddate']).local().format('MM/DD/YYYY hh:mm A')} {this.getTimeZone()}</div>
                        </div>
                        {/* <div style={{ margin: "0 5%" }}> */}
                            {/* <div style={{color:"#808080"}}></div> */}
                        {/* </div> */}
                        { row['itemcount'] === 0 ?
                        <div style={{ marginLeft: "-2%" }}>
                           <img src={`${process.env.PUBLIC_URL}/static/icons/sidebar/delete.svg`} alt="delete" height="20px" width="20px" style={{ right: "10px", cursor: "pointer" }} onClick={()=> this.setState({ SaleId: row.id, deleteModal:true , deleteStatus: { show: false, type: '', message: '' }}) }/> 

                            {/* <Button size="sm" className="mx-6" variant="secondary" onClick={()=> this.setState({ SaleId: row.id, deleteModal:true , deleteStatus: { show: false, type: '', message: '' }}) }>Delete</Button> */}
                        </div>
                        : ''}
                    </div>
                    : ''}
            </div>
        );
    }

    getTimeZone = () => {
        const timeZone = momentTz.tz.guess();
        return momentTz.tz(timeZone).zoneAbbr();
    }

    updateTableData = (data) => {
        if (data) {
            this.tableData = data;
            this.setState({
                ...this.state,
                tableData: data
            });
            this.getNotesCount()
        }
    }

    handleDateChangeRaw = (e) => {
        e.preventDefault();
    }

    /* Called when delete button confirmed */
    deleteSale = () => {
        this.setState({ deleteLoading: true });
        
        const data = {
        "saleid": this.state.SaleId,
        };
        axios.delete(getSellerUrl(saledelete+this.state.SaleId), { ...getSellerHeaders(), data: { 'data': data } })
        .then(response => {
            if (response.status === 200) {
                this.enableSearch();
                this.setState({
                    ...this.state,
                    deleteLoading: false,
                    deleteStatus: { show: true, type: 'success', message:"Sale has been deleted successfully" }
                });
            } 
        })
        .catch(error => { 
            this.setState({
                ...this.state,
                deleteLoading:false,
                deleteStatus: { show: true, type: 'danger', message: error?.response?.data?.message }
            });
        });
    }
    render() {
        if (this.state.errorpageredirect) {
            return <NoData {...this.props} type={this.state.errorType} />
        }
        return (
            <div style={{ overflow: "auto", overflowY: "overlay" }}>
                <div className="sale-search" style={{ backgroundColor:'#BBC7D6' }}>
                    <div className="sales-list-search">
                        <Form className="sales-list-font">
                            <div className="sales-search-container">
                                <Row>
                                    <Col>
                                        <label>Sale Title</label>
                                        <Form.Control onKeyDown={this._handleKeyDown} type="text" name="title" value={this.state.search.title.value} onChange={(event) => this.searchInputChange(event)} />
                                    </Col>

                                    <Col>
                                        <label>Client Name</label>
                                        <Form.Control onKeyDown={this._handleKeyDown} type="text" name="client" value={this.state.search.client.value} onChange={(event) => this.searchInputChange(event)} />
                                    </Col>

                                    <Col>
                                        <label>Starting Before</label>
                                        <div>
                                            <label style={{ width: "100%" }} onClick={e => this.start.state.open && e.preventDefault()}>
                                                <DatePicker ref={r => this.start = r} className="datePicker" dateFormat="MM/dd/yyyy" value={this.state.search.starttime.value} selected={this.state.search.starttime.value} onChange={date => { this.setDate('starttime', date) }} onChangeRaw={this.handleDateChangeRaw} peekNextMonth showMonthDropdown showYearDropdown placeholderText="MM/DD/YYYY" dropdownMode="select" />
                                                <i style={{ position: "absolute", top: "55%", right: "25px", color: "#00263E" }} className="fa fa-calendar" aria-hidden="true"></i>
                                            </label>
                                        </div>
                                    </Col>
                                    <Col>
                                        <label>Starting After</label>
                                        <div>
                                            <label style={{ width: "100%" }} onClick={e => this.end.state.open && e.preventDefault()}>
                                                <DatePicker maxDate={this.state.search.starttime.value ? this.state.search.starttime.value : ''} ref={r => this.end = r} className="datePicker" dateFormat="MM/dd/yyyy" value={this.state.search.endtime.value} selected={this.state.search.endtime.value} onChange={date => { this.setDate('endtime', date) }} onChangeRaw={this.handleDateChangeRaw} peekNextMonth showMonthDropdown showYearDropdown placeholderText="MM/DD/YYYY" dropdownMode="select" />
                                                <i style={{ position: "absolute", top: "55%", right: "25px", color: "#00263E" }} className="fa fa-calendar" aria-hidden="true"></i>
                                            </label>
                                        </div>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <label>State</label>
                                        <Form.Control as="select" name="state" value={this.state.search.state.value} onChange={(event) => this.searchInputChange(event)}>
                                            <option value="" disabled>Select State</option>
                                            {
                                                this.state.stateList.map((state, idx) => <option key={idx} value={state['state']}>{state['state']}</option>)
                                            }
                                        </Form.Control>
                                    </Col>
                                    <Col>
                                        <label>City</label>
                                        <Form.Control as="select" name="city" value={!this.state.search.state.value ? !this.state.search.city.value : this.state.search.city.value} disabled={!this.state.search.state.value} style={{textTransform: "capitalize"}} onChange={(event) => this.searchInputChange(event)}>
                                            <option value="" selected>Select City</option>
                                            <option value="All" selected>All</option>
                                            {this.state.cityList.map((city, index) =>
                                                <option key={index} value={city.city}>{city.city}</option>
                                            )}
                                        </Form.Control>
                                    </Col>
                                    <Col>
                                        <label>Zip Code</label>
                                        <Form.Control onKeyDown={this._handleKeyDown} type="text" name="zipcode" value={this.state.search.zipcode.value} onChange={(event) => this.searchInputChange(event)} />
                                    </Col>

                                    <Col>
                                        <label>Location</label>
                                        <Form.Control as="select" name="locationid" value={this.state.search.locationid.value} onChange={(event) => this.searchInputChange(event)}>
                                            <option disabled value="">Select Location</option>
                                            {this.state.locationlength > 1 ? <option value="All">All</option> : ''}
                                            {this.state.locations.map((loc, index) =>
                                                <option key={index} value={loc.id}>{loc.title}</option>
                                            )}
                                        </Form.Control>
                                    </Col>
                                </Row>
                                <Row className="d-flex" style={{ marginBottom: "-1%" }}>
                                    <Col >
                                        {/* <Form>
                                            <Form.Check inline style={{ marginRight: "5%" }} type="checkbox" name="active" checked={this.state.search.active.value} label="Active Sales" id="active" onChange={(event) => this.searchInputChange(event)} />
                                            <Form.Check inline type="checkbox" name="inactive" checked={this.state.search.inactive.value} label="Inactive Sales" onChange={(event) => this.searchInputChange(event)} />
                                        </Form> */}
                                    </Col>
                                    <Col md={6} className="d-flex justify-content-center align-items-center">
                                        {(this.state.errorMessage || this.state.locationErrorMsg) && (
                                            <div className="text-danger text-center" style={{fontSize: '14px'}}>
                                                {this.state.errorMessage ? this.state.errorMessage :  this.state.locationErrorMsg}
                                            </div>
                                        )}
                                    </Col>
                                    <Col >
                                    {/* {window.innerWidth < 425?
                                    <div className="scroll-indicator">
                                    <span className="mx-1">Scroll down</span>
                                    <i className="fas fa-angle-down "></i>
                                   </div>:""
                                    } */}
                                        <div className="buttonClass">
                                            <Button className="clear-button" onClick={() => this.resetState()}>Clear All</Button>
                                            <Button variant="seller-search" disabled={(this.state.errorMessage || this.state.locationErrorMsg )} onClick={() => this.enableSearch()}>Search</Button>
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                        </Form>
                    </div>
                </div>
                {this.state.modal ?
                    <Notes modal={this.state.modal} id={this.id} name='sale' hideNotes={this.hideNotes} data={this.state.salesDetails} getNotesCount={this.getNotesCount} /> : ''
                }
                <div className="sale-list">
                    {/* need to add props, as it provides the previous state of datatable */}
                    <Datatable {...this.props} config={{ ...this.config }} search={this.state.searchData ? { search: { ...this.state.filterSearch }, searchData: this.state.searchData } : null} ref={this.dataTable} onDataUpdate={this.updateTableData} showNotesGreenCircle></Datatable>
                </div>
                <Modal centered show={this.state.deleteModal} size="md" animation={false} onHide={() => { this.setState({ deleteModal:false }) }} keyboard={false}>
                    <Modal.Body>
                        <div className="d-flex flex-column justify-content-center align-items-center">
                           Are you sure you want to delete this sale ?
                           <div id="toaster" className={this.state.deleteStatus.show ? " d-flex flex-row align-items-center justify-content-center toaster" : ''}  style={{paddingTop: "3%"}} >
                           {
                               this.state.deleteStatus.show ?
                              <ToasterMessage type={this.state.deleteStatus.type} message={this.state.deleteStatus.message} className="alert-handle"></ToasterMessage>
                             : null
                            }
                         </div> 
                            <div className="d-flex flex-row mt-4">
                                <Button variant="outline-dark btn-white mx-2" style={{ width: '120px' }} onClick={() => { this.setState({ deleteModal:false }) }}>No</Button>
                                <Button variant="secondary mx-2" style={{ width: '120px' }} disabled={this.state.deleteStatus.type === 'success' || this.state.deleteStatus.type === 'danger'} onClick={() => this.deleteSale()}>Yes {this.state.deleteLoading ? <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /> : ''}</Button>
                            </div>
                        </div>
                    </Modal.Body>
                </Modal>
            </div>
        );
    }
}